import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { finishAuth } from ".";
import { COLOR_NAVY } from "../common/constants";

class OAuthCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
    };
  }

  componentDidMount() {
    finishAuth(new URLSearchParams(window.location.search)).then(
      (returnPath) => {
        this.setState({ redirect: returnPath || "/" });
      }
    );
  }

  render() {
    if (!this.state.redirect) {
      return (
        <CircularProgress
          style={{ color: COLOR_NAVY }}
          size={100}
          thickness={1}
        />
      );
    }

    return <Redirect to={this.state.redirect} />;
  }
}

export default OAuthCallback;
